import { render, staticRenderFns } from "./EditBaseInfo.vue?vue&type=template&id=d0d36872&"
import script from "./EditBaseInfo.vue?vue&type=script&lang=js&"
export * from "./EditBaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports